<div
  class="bg-white rounded-10 p-5 max-sm:p-3 text-16 max-sm:text-12 font-roboto-400 flex flex-col gap-5"
>
  @for (_ of [1, 2, 3, 4, 5]; track $index) {
  <div class="flex justify-between items-center">
    <div class="flex gap-3 items-center">
      <div class="border border-grey-5 p-1">
        <div
          class="w-[15px] h-[15px] rounded-l-8 bg-grey-skeleton animate-pulse"
        ></div>
      </div>
      <span class="bg-grey-skeleton animate-pulse w-44 h-7"></span>
    </div>
    <span class="bg-grey-skeleton animate-pulse w-48 h-7"></span>
  </div>
  }
</div>
